import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	viewObjectDetails: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	viewObjectDetails: {
		id: 'servicedesk-insight-attribute-list.button-attribute-with-avatar.view-object-details',
		defaultMessage: 'View details',
		description: 'Tooltip label shown on the object attribute link',
	},
});
export default messages;
